import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicMonitoringBandwidthStatsParamsRawI,
	LWApiPublicMonitoringBandwidthStatsResultsRawI,
} from '@liquidweb-dev/club-sauce/public/monitoring/bandwidth/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const MONITORING_BANDWIDTH_STATS_QUERY_KEY =
	'/monitoring/bandwidth/stats';

const useMonitoringBandwidthStats = (
	params: LWApiPublicMonitoringBandwidthStatsParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicMonitoringBandwidthStatsResultsRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [MONITORING_BANDWIDTH_STATS_QUERY_KEY, params],
		queryFn: () => api.monitoring.bandwidth.apiRaw.stats(params),
		...options,
	});

export default useMonitoringBandwidthStats;
